import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
}

/**
 * ProtectedRoute component that handles role-based access control
 * Redirects unauthorized users to the home page
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false
}) => {
  const { user } = useAuth();

  // If route requires admin and user is not admin, redirect to home
  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  // User has access, render the component
  return children;
};

export default ProtectedRoute;
